import type { IntegrationProviders } from '@vy/types';
import type { ValueOf } from '@vy/utils';

export const INTEGRATIONS_TYPES = {
  ERP: 'ERP',
  CRM: 'CRM',
  Payment: 'Payment',
  Communication: 'Communication',
  Storage: 'Storage',
  Api: 'API',
  Tax: 'Tax',
  Marketplace: 'Marketplace',
} as const;

export type IntegrationType = ValueOf<typeof INTEGRATIONS_TYPES>;

export type getIntegrationMetadataResponse = {
  connectedIntegrations: IntegrationProviders[];
  disconnectedIntegrations: IntegrationProviders[];
};
